import { useState, useEffect } from 'react';
import { getSlots } from '../config/apiConfig';
import slice_in_weeks from '../utils';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/es';
moment.locale('es');

const useMonth = (initialStart = moment()) => {
  const [slots, setSlots] = useState([]);
  const [month, setMonth] = useState({
    start: moment(initialStart).startOf('M'), end: moment(initialStart).startOf('M').add(1, 'M')
  });

  useEffect(() => {
    getSlots(moment(month.start).format('L'), moment(month.start).daysInMonth())
      .then(res => {
        let results = []

        //complete initial month days
        for (let i = 1; i < moment(month.start).isoWeekday(); i++) {
          results.push({ available: false, date: null });
        };

        Object.values(res.data.slots).map((slots, i) => {
          let slot_available = false;
          slots.map(slot => {
            if (slot.available) slot_available = true;
          })
          results.push({
            available: slot_available,
            date: moment(
              `${i + 1}/${month.start.format('MM')}/${month.start.format('YYYY')}`, 'DD/MM/YYYY'
            )
          });
        });

        setSlots(slice_in_weeks(results));
      })
      .catch(err => console.error(err));
  }, [month]);

  const prevMonth = () => {
    if (moment().isSameOrBefore(moment(month.start)))
      setMonth(month => ({
        start: moment(month.start).subtract(1, 'M'), end: moment(month.end).subtract(1, 'M')
      }));
  };

  const nextMonth = () => setMonth(month => ({
    start: moment(month.start).add(1, 'M'), end: moment(month.end).add(1, 'M')
  }));

  return {
    month,
    slots,
    prevMonth,
    nextMonth
  };
};

export default useMonth;